import { defineFeatureFlag, useBooleanFlag } from '@heidi/runtime/feature-flags';
import { isTauri } from '@heidi/runtime/platform';

// One switch per product, each the key the backend serve route also evaluates
// before it fills that product's formats. Keys are Flagsmith identities:
// renaming one switches flags.

/** Sponsored placements in Evidence: the home banner and both loading cards. */
export const evidenceAdsEnabledFlag = defineFeatureFlag({
  key: 'release-evidence-enable-ads',
  defaultValue: false,
  description: 'Sponsored placements in Evidence',
});

/** Sponsored placements in Scribe: the note-generation card. */
export const scribeAdsEnabledFlag = defineFeatureFlag({
  key: 'release-scribe-enable-ads',
  defaultValue: false,
  description: 'Sponsored placements in Scribe note generation',
});

/**
 * Ads are web-only until they ship on desktop. A desktop build keeps the
 * frontend it was cut with, so the flag alone can't keep an unfinished build
 * ad-free.
 */
const isAdsPlatform = (): boolean => !isTauri();

export const useIsEvidenceAdsEnabled = (): boolean => {
  const isEnabled = useBooleanFlag(
    evidenceAdsEnabledFlag.key,
    evidenceAdsEnabledFlag.defaultValue
  );
  return isAdsPlatform() && isEnabled;
};

export const useIsScribeAdsEnabled = (): boolean => {
  const isEnabled = useBooleanFlag(
    scribeAdsEnabledFlag.key,
    scribeAdsEnabledFlag.defaultValue
  );
  return isAdsPlatform() && isEnabled;
};

/**
 * FE rollout gate for clinician (NPI) verification of existing US users.
 * Defaults OFF; the backend gate on `/hcp-verifications` stays the source of
 * truth for eligibility.
 */
export const userHcpVerificationFlag = defineFeatureFlag({
  key: 'release-user-hcp-verification',
  defaultValue: false,
  description: 'Clinician (NPI) verification of existing US users',
});

export const useIsUserHcpVerificationEnabled = (): boolean =>
  useBooleanFlag(userHcpVerificationFlag.key, userHcpVerificationFlag.defaultValue);
